<div class='ili-panel placefull_panel'>
<p style="font-size: 11px;">Copy and paste the PlaceFull script and div</p>
<textarea [(ngModel)]="block.data.text" class="placefull"></textarea>
</div>
